import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { MessageCircle, ArrowRight } from "lucide-react";
import { mockData } from "../mock";

export const FAQ = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl font-bold text-gray-900">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Find clear answers to commonly asked questions about our programs,
            learning methodology and support services{" "}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* FAQ Accordion */}
          <Card className="bg-white shadow-lg">
            <CardContent className="p-8">
              <Accordion type="single" collapsible className="space-y-4">
                {mockData.faqs.map((faq, index) => (
                  <AccordionItem
                    key={index}
                    value={`item-${index}`}
                    className="border border-gray-200 rounded-lg px-6"
                  >
                    <AccordionTrigger className="text-left hover:no-underline py-6">
                      <span className="font-semibold text-gray-900 pr-4">
                        {faq.question}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6">
                      <p className="text-gray-700 leading-relaxed flex flex-col gap-2">
                        {faq.answer}
                        <span>{faq.answerTwo}</span>
                      </p>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>

          {/* Additional Support */}
          <div className="mt-12 text-center space-y-6">
            <h3 className="text-2xl font-bold text-gray-900">
              Still Have Questions?
            </h3>

            <p className="text-gray-600 max-w-2xl mx-auto">
              Our admissions advisors are ready to guide you through your
              academic journey. Connect with us to discuss curriculum details,
              financial planning, and your career trajectory.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg flex items-center gap-2"
                onClick={() =>
                  window.open(
                    "https://api.whatsapp.com/send?phone=919895223307",
                    "_blank"
                  )
                }
              >
                <MessageCircle size={20} />
                Chat on WhatsApp
              </Button>

              <Button
                variant="outline"
                type="button"
                className="px-8 py-6 text-lg border-2 hover:bg-gray-50"
                onClick={() =>
                  window.open(`tel:${mockData.contact.phone}`, "_self")
                }
              >
                Call {mockData.contact.phone}
              </Button>
            </div>

            {/* Quick Contact Info */}
            <div className="grid md:grid-cols-3 gap-6 mt-12 max-w-3xl mx-auto">
              <div className="text-center space-y-2">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                  <MessageCircle className="w-6 h-6 text-blue-600" />
                </div>
                <h4 className="font-semibold text-gray-900">WhatsApp</h4>
                <p className="text-sm text-gray-600">
                  Connect for Instant Support{" "}
                </p>
                <p className="text-sm text-blue-600">
                  {mockData.contact.phone}
                </p>
              </div>

              <div className="text-center space-y-2">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                  <ArrowRight className="w-6 h-6 text-green-600" />
                </div>
                <h4 className="font-semibold text-gray-900">Email</h4>
                <p className="text-sm text-gray-600">
                  {" "}
                  Inquire for Comprehensive Details
                </p>
                <p className="text-sm text-green-600">
                  {mockData.contact.email}
                </p>
              </div>

              <div className="text-center space-y-2">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto">
                  <ArrowRight className="w-6 h-6 text-purple-600" />
                </div>
                <h4 className="font-semibold text-gray-900">Visit Us</h4>
                <p className="text-sm text-gray-600">
                  Schedule a Personalized Campus Visit{" "}
                </p>
                <p className="text-sm text-purple-600">Govt.Cyberpark, Kozhikode</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
